<template>
  <div class="wido-input-number flex whitespace-nowrap">
    <template v-if="controlsPosition">
      <button type="button" class="wido-btn wido-btn-down" :class="disabled && 'cursor-default'"
        @click.stop="updateModelValue(Number(modelValueNum) - 1)" :disabled="disabled">
        <svg t="1703130482512" class="icon" :class="modelValue <= 1 ? 'opacity-10' : 'opacity-100'"
          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5591" width="16" height="15">
          <path
            d="M225.408 368.384L496 640.641l270.592-272.257-48.64-49.024L496 542.592 274.176 319.36l-48.768 49.024z m0 0z"
            :fill="btnDownHover ? '#fff' : '#222226'" p-id="5592"></path>
        </svg>
      </button>
      <input class="wido-input grow text-center text-sm" :disabled="disabled" v-model="modelValueNum" type="number"
        @change="updateModelValue($event.target.value)" />
      <button type="button" class="wido-btn wido-btn-up" :class="disabled && 'cursor-default'"
        @click.stop="updateModelValue(Number(modelValueNum) + 1)" :disabled="disabled">
        <svg t="1703130406828" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="4471" width="16" height="15">
          <path
            d="M512 471.466667l181.034667 181.034666a42.666667 42.666667 0 1 0 60.330666-60.330666l-211.2-211.2a42.666667 42.666667 0 0 0-60.330666 0l-211.2 211.2a42.666667 42.666667 0 1 0 60.330666 60.330666L512 471.466667z"
            :fill="btnUpHover ? '#fff' : '#222226'" p-id="4472"></path>
        </svg>
      </button>
    </template>
    <template v-else>
      <input class="wido-input grow text-center text-sm" :disabled="disabled" v-model="modelValueNum" type="number"
        @change="updateModelValue($event.target.value)" />
      <div class="flex flex-col justify-center items-center wido-btn-group">
        <button type="button" class="wido-btn wido-btn-up" :class="disabled && 'cursor-default'"
          @click.stop="updateModelValue(Number(modelValueNum) + 1)" :disabled="disabled">
          <svg t="1703130406828" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4471" width="16" height="12">
            <path
              d="M512 471.466667l181.034667 181.034666a42.666667 42.666667 0 1 0 60.330666-60.330666l-211.2-211.2a42.666667 42.666667 0 0 0-60.330666 0l-211.2 211.2a42.666667 42.666667 0 1 0 60.330666 60.330666L512 471.466667z"
              :fill="btnUpHover ? '#fff' : '#222226'" p-id="4472"></path>
          </svg>
        </button>
        <button type="button" class="wido-btn wido-btn-down" :class="disabled && 'cursor-default'"
          @click.stop="updateModelValue(Number(modelValueNum) - 1)" :disabled="disabled">
          <svg t="1703130482512" class="icon" :class="modelValue <= 1 ? 'opacity-10' : 'opacity-100'"
            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5591" width="16" height="12">
            <path
              d="M225.408 368.384L496 640.641l270.592-272.257-48.64-49.024L496 542.592 274.176 319.36l-48.768 49.024z m0 0z"
              :fill="btnDownHover ? '#fff' : '#222226'" p-id="5592"></path>
          </svg>
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
import { notification } from "@/utils/notification";
import { ElMessage } from "element-plus";
import { nextTick, ref, watch } from "vue";
const props = defineProps({
  modelValue: Number,
  disabled: { type: Boolean, default: false },
  setting: { type: Object },
  onNumChange: Function,
  item: { type: Object, default: () => ({}) },
  controlsPosition: { type: Boolean, default: false }, // 控制按钮位置
});

const modelValueNum = ref(typeof props.modelValue === 'number' && props.modelValue > 0 ? props.modelValue : 1);

// hover 状态
const btnUpHover = ref(false);
const btnDownHover = ref(false);

watch(() => props.modelValue, (v) => {
  modelValueNum.value = typeof v === 'number' && v > 0 ? v : 1;
})

const emits = defineEmits(["updateNum"]);
function updateModelValue(newValue) {
  if (props.disabled) {
    return;
  }
  let value = Number(newValue);
  const min = props.setting?.min ?? 1;
  if (isNaN(value) || value < min) {
    value = min;
    ElMessage({
      message: `数量不能小于${min}`,
      type: 'warning',
    })
  }
  emits("updateNum", { value, item: props.item });
}
</script>

<style lang="scss" scoped>
.wido-input-number {
  background: transparent;
  /* 不设置边框和圆角，交由外部控制 */
  overflow: hidden;

}

.wido-input {
  width: auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  border-radius: 0;
  padding: 0;
  height: 100%;
}

.wido-btn-group {
  height: 100%;
  flex: 0 0 30px;
}

.wido-btn {
  width: 30px;
  height: 100%;
  background: #F3F3F8;
  color: #222226;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
  cursor: pointer;
  font-size: 20px;
  padding: 0;
}

.wido-btn-up {
  border-bottom: 1px solid #F3F3F8;
  border-radius: 0;
}

.wido-btn-down {
  border-radius: 0;
}

.wido-btn:hover:not(:disabled) {
  background: #47496F;
  color: #fff;
}

.wido-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
